import React from "react";
import {
  Datagrid,
  
  List,
  TextField,
} from "react-admin";

export const ProductList = (props) => {
  return (
    <List
      {...props}
     
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
      </Datagrid>
    </List>
  );
};